var map = {
	"./flag-bg.svg": 952,
	"./flag-cs.svg": 884,
	"./flag-de.svg": 324,
	"./flag-en.svg": 244,
	"./flag-es.svg": 492,
	"./flag-fr.svg": 480,
	"./flag-it.svg": 938,
	"./flag-pl.svg": 388,
	"./flag-uk.svg": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;